module.exports = __webpack_public_path__ + "img/lappset-2023.de98bb70.png";